<template>
  <div class="main">
    <!-- loading 一键生成 -->
    <div
      class="loadings"
      v-if="loading"
      v-loading="{ visible: loading, text: loadingtext }"
    ></div>
    <heads></heads>
    <banners></banners>
    <div class="content">
      <div class="cons">
        <!-- 生成论文 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">生成大纲</div>
            <el-form-item label="关键词">
              <el-input v-model="form.bt" placeholder="请输入关键词或句子" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="danger" @click="clickdagang()"
                >生成大纲</el-button
              >
            </div>
            <el-form-item label="大纲">
              <el-input autosize type="textarea" v-model="reslunwenmini" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="danger" @click="clickquanwen()"
                >生成全文</el-button
              >
            </div>
            <el-form-item label="全文">
              <el-input autosize type="textarea" v-model="reslunwen" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { post } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, ref, inject, getCurrentInstance } from "vue";
import "echarts-wordcloud";
import { useRouter } from "vue-router";

const router = useRouter();
const { proxy } = getCurrentInstance();

const baseurls = "http://server-1:8055";
// loading
let loading = ref(false);
let loadingtext = ref(" ");
let randsum = 0;
// 提纲
let tigang = ref("");
// 引言
let yinyan = ref("");
let cankaowenxian = ref("参考文献：\n");
// 摘要关键词
let zhaiyaoguanjianci = ref("");
// 每个问题的结果
let reswenti1 = ref("");
let reswenti2 = ref("");
let reswenti3 = ref("");
let reswenti4 = ref("");

let reswenti6 = ref("");
// 全文
let reslunwen = ref("");
let reslunwenmini = ref("");

let resobj = ref("");
let form = reactive({
  bt: "",
  ckwx: [],
  writerorg: `学术论文“论文标题“选择要求有一定的“创新性“、”实用性“和”科学性“等要求。假如你是一名顶级学者，请围绕 “@标题@”的中心内容意思，生成十篇题目供参考，每个论文标题只写一句话。中间不能出现符号，又如“ XXX”，输出格式为：
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX．
请注意用Markdown格式输出, 以下是关键词：`,
  writerorg2: "",
  resobj: "",
});
let form2 = reactive({
  bt: "",
  zz: "顶级学者",
  writerorg: `假如你是一名@身份@，请围绕 “@标题@”的中心内容意思，生成一篇学术论文大纲，请注意用”阿拉伯数字“编号。
论文提纲各级标题要有新颖性。第三部份需要插入一个数据表，数据不能缺失，模拟数据也可以。后面扩写过程中，还会针对表中的数据进行具体的文字分析。
大纲围绕“@标题@”分为六部分。如示例只写到二级标题，每一级都要按示例写满，不要多写也不要少写。
请根据以下关键词并进行组合，并用MARKDOWN格式输出。如 (引言部分)（第一部分）（第二部分）（第三部分）（第四部分）（结束语部分），不要出现失误。
输出格式为： 
（引言部分）
0 引言（XXX，围绕开题写一段话，如研究目的、方法、问题等。500汉字左右）。
（第一部分）
1 XXX（1.1；1.2；1.3；）
（第二部分）
2 XXX（2.1；2.2；2.3；2.4；）
（第三部分）
3 XXX（3.1；3.2；3.3；3.4；）
（第四部分）
4 XXX（4.1；4.2；4.3；）
（结束语部分）
5 结束语（XXX，围绕大纲总结阐述结果、结论、打算等）`,
  writerorg2: "",
});
let form01 = reactive({
  writerorg2: "",
  writerorg: `假如你是一名@身份@，请围绕 “@标题@”学术论文提纲的第一部分。请逐条执行以下命令，特别是第7条。
1、请根据下面提交的内容按学术论文风格，扩写到2000个字。为保证全文连续性，将全部大纲提交供参考。
2、注意只保留一级标题前面的阿拉伯数字序号。如“1”。
3、二级标题要求重新提炼，同时注意新颖性与全文提纲的逻辑关系，按学术论文风格，扩写到2000个字。
4、只扩写指定的“（第一部分）”或者“1.X”部分的内容，并按学术论文风格扩写输出。其他部分的内容在此不扩写与润色。
5、输出前，请再次确认输出汉字字数要求。输出前请确认在最后一段文字中不要出现“综上所述”或者“总之”这种词语。
6、特别提醒：经常出现输出字数不够的问题。要按字数要求扩写。请一定要认真核对字数要求后，扩写部份满足2000个字数要求才输出。
7、按学术论文风格，扩写到2000个字。
大纲如下：`,
});
let form02 = reactive({
  writerorg2: "",
  writerorg: `假如你是一名@身份@，请围绕“@标题@”学术论文提纲的第二部分。请逐条执行以下命令，特别是第7条。
1、请根据下面提交的内容按学术论文风格，将“第二部分”或者“2.X”的内容扩写到2000个字。为保证全文连续性，我也将全部大纲提交供参考。同时，标题要求重新提炼。
2、注意只保留标题前面的阿拉伯数字序号。如“2”。
3、标题要求重新提炼，同时注意新颖性与全文提纲的逻辑关系，按学术论文风格，扩写到2000个字。
4、只扩写指定“第二部分”或者“2.X”部分的内容，并按学术论文风格扩写输出。其他部分的内容在此不扩写与润色。
5、输出前，请再次确认输出汉字字数要求。输出前请确认在最后一段文字中不要出现“综上所述”或者“总之”这种词语。
6、特别提醒：经常出现输出字数不够的问题。要按字数要求扩写。请一定要认真核对字数要求后，扩写部分满足2000个字数要求才输出。
7、按学术论文风格，扩写到2000个字。
大纲如下： `,
});
let form03 = reactive({
  writerorg2: "",
  writerorg: `假如你是一名@身份@，请围绕 “@标题@”学术论文提纲的第三部分。请逐条执行以下命令，特别是第7条。
1、请根据下面提交的内容按学术论文风格，将“第三部分“或者“3.X”的内容扩写到2000个字。为保证全文连续性，我也将全部大纲提交供参考。同时，标题要求重新提炼。
2、注意只保留标题前面的阿拉伯数字序号。如“3”。
3、标题要求重新提炼，同时注意新颖性与全文提纲的逻辑关系，按学术论文风格，扩写到2000个字。
4、只扩写指定“第三部分”或者“3.X“部分的内容，并按学术论文风格扩写输出。其他部分的内容在此不扩写与润色。第三部份需要插入一个数据表，数据不能缺失，模拟数据也可以。并要针对表中的数据进行具体的文字分析。
5、输出前，请再次确认输出汉字字数要求。输出前请确认在最后一段文字中不要出现“综上所述”或者 “总之”这种词语。
6、特别提醒：经常出现输出字数不够的问题。要按字数要求扩写。请一定要认真核对字数要求后，扩写部份满足2000个字数要求才输出。
7、按学术论文风格，扩写到2000个字。
大纲如下：`,
});
let form04 = reactive({
  writerorg2: "",
  writerorg: `假如你是一名@身份@，请围绕 “@标题@”学术论文提纲的第四部分。请逐条执行以下命令，特别是第7条。
1、请根据下面提交的内容按学术论文风格，将“第四部分”或者“4.X“的内容扩写到2000个字。为保证全文连续性，我也将全部大纲提交供参考。同时，标题要求重新提炼。
2、注意只保留标题前面的阿拉伯数字序号。如“4”。
3、标题要求重新提炼，同时注意新颖性与全文提纲的逻辑关系，按学术论文风格，扩写到2000个字。
4、只扩写指定的“第四部分”或者“4.X“部分的内容，并按学术论文风格扩写输出。其他部分的内容在此不扩写与润色。
5、输出前，请再次确认输出汉字字数要求。输出前请确认在最后一段文字中不要出现“综上所述”或者 “总之”这种词语。
6、特别提醒：经常出现输出字数不够的问题。要按字数要求扩写。请一定要认真核对字数要求后，扩写部份满足2000个字数要求才输出。
7、按学术论文风格，扩写润色到2000个字。
大纲如下：`,
});

let form06 = reactive({
  writerorg2: "",
  writerorg: `假如你是一名@身份@，请围绕 “@标题@”学术论文提纲的结束语部分。
请根据下面提交的大纲的中“结束语部分”的内容进行写作，不要展开其他部分的内容。不要分点描述，而是要整合起来写。结合前面输出的内容，不要再重复写。修改润色后，结束语部分输出600字。
大纲如下：`,
});

let formzhiayaoguanjianci = reactive({
  writerorg: `根据提交的大纲内容生成论文的摘要和关键词，注意，摘要400字左右，格式如下：
摘要：随着XX（直接输出在“摘要：”后面不换行）
关键词：XX；XX
大纲内容：`,
});

// 生成标题
const onSubmit11 = () => {
  return post(baseurls + "/api/Kw/GetSearchZl", {
    bt: form.bt,
    sentence: "",
    subhs: "",
  }).then((res) => {
    form.writerorg2 = res.data;
  });
};
const onSubmit12 = () => {
  let temphs = form.writerorg.replace("@标题@", form.bt);
  return post(baseurls + "/api/Kw/GetZlCuts", {
    bt: form.bt,
    sentence: form.writerorg2,
    subhs: temphs,
  }).then((res) => {
    form.resobj = res.data.resdata;
  });
};
// 选定标题
const onSubmit13 = () => {
  return post(baseurls + "/api/Kw/GetTitleTj", {
    sentence: form.resobj,
  }).then((res) => {
    form2.bt = res.data.bt[0].title;
  });
};

// 生成参考文献 异步
const onSubmit121 = () => {
  cankaowenxian.value = "参考文献：\n";
  post(baseurls + "/api/Kw/GetCkwxTj", {
    sentence: form2.bt,
  }).then((res) => {
    form.ckwx = res.data.list;
    form.ckwx.forEach((e) => {
      cankaowenxian.value += `${e}\n`;
    });
  });
};

// 生成大纲
const onSubmit21 = () => {
  // 替换话术
  let temphs = form2.writerorg.replace(/@标题@/g, form2.bt);
  form2.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetDgChatAPI", {
    sentence: form2.writerorg2,
  }).then((res) => {
    tigang.value = res.data.yw;
    yinyan.value = res.data.yy;
  });
};

// 生成摘要关键词
const clickzhaiyaoguanjianci = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: formzhiayaoguanjianci.writerorg + tigang.value,
  }).then((res) => {
    zhaiyaoguanjianci.value = res.data;
    // 生成reslunwenmini  标题  摘要关键字  引言   参考文献
    reslunwenmini.value = "";
    reslunwenmini.value += `
        ${form2.bt}\n
        ${zhaiyaoguanjianci.value}\n
        ${tigang.value}\n
        ${cankaowenxian.value}
    `;
  });
};

// 生成第一部分
const onSubmit001 = () => {
  // 替换话术
  let temphs = form01.writerorg.replace(/@标题@/g, form2.bt);
  form01.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form01.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti1.value = res.data;
  });
};
// 生成第二部分
const onSubmit002 = () => {
  // 替换话术
  let temphs = form02.writerorg.replace(/@标题@/g, form2.bt);
  form02.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form02.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti2.value = res.data;
  });
};
// 生成第三部分
const onSubmit003 = () => {
  // 替换话术
  let temphs = form03.writerorg.replace(/@标题@/g, form2.bt);
  form03.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form03.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti3.value = res.data;
  });
};
// 生成第四部分
const onSubmit004 = () => {
  // 替换话术
  let temphs = form04.writerorg.replace(/@标题@/g, form2.bt);
  form04.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form04.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti4.value = res.data;
  });
};
// 生成结束语部分
const onSubmit006 = () => {
  // 替换话术
  let temphs = form06.writerorg.replace(/@标题@/g, form2.bt);
  form06.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form06.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti6.value = res.data;
    //生成全文  标题  摘要关键字  引言   正文   参考文献
    reslunwen.value = `
        ${form2.bt}\n
        ${zhaiyaoguanjianci.value}\n
        ${yinyan.value}\n
        ${reswenti1.value}\n
        ${reswenti2.value}\n
        ${reswenti3.value}\n
        ${reswenti4.value}\n
        ${reswenti6.value}\n
        ${cankaowenxian.value}
      `;
  });
};

// 同步生成大纲
const clickdagang = async () => {
  if (form.bt.trim() == "") {
    ElMessage({
      message: "请填写关键词",
      type: "warning",
    });
    return;
  }
  loading.value = true;
  loadingtext.value = "正在生成中，当前进度0%，请耐心等待...";
  // 初始化
  randsum = 0;
  let conouttime = 80 + Math.floor(Math.random() * 5) + 1;
  loadingfun(conouttime);
  // 顺序执行方法
  await onSubmit11();
  await onSubmit12();
  await onSubmit13();
  onSubmit121(); //参考文献
  await onSubmit21();
  await clickzhaiyaoguanjianci();

  loading.value = false;
};

// 同步生成正文
const clickquanwen = async () => {
  if (tigang.value == "") {
    ElMessage({
      message: "还没有生成大纲",
      type: "warning",
    });
    return;
  }
  loading.value = true;
  loadingtext.value = "正在生成中，当前进度0%，请耐心等待...";
  // 初始化
  randsum = 0;
  let conouttime = 200 + Math.floor(Math.random() * 5) + 1;
  loadingfun(conouttime);
  // 顺序执行方法
  await onSubmit001();
  await onSubmit002();
  await onSubmit003();
  await onSubmit004();
  await onSubmit006();

  loading.value = false;
};

const loadingfun = (outtime) => {
  let randNumtemp = Math.floor(Math.random() * 5) + 1;
  if (loading.value) {
    setTimeout(() => {
      randsum += randNumtemp;
      if (randsum < outtime) {
        let temprandnum = ((randsum / outtime) * 100).toFixed(2);
        loadingtext.value = `正在生成中，当前进度${temprandnum}%，请耐心等待...`;
        loadingfun(outtime);
      } else {
        loadingtext.value = `正在生成中，当前进度99.99%，请耐心等待...`;
      }
    }, randNumtemp * 1000);
  }
};
</script>

<style scoped>
:deep(.el-form-item__label) {
  background: #f5f7fa;
  height: 42px;
  line-height: 42px;
  font-size: 18px;
}
:deep(.cons-form .el-input__inner) {
  height: 40px;
  font-size: 18px;
}
:deep(.cons-form .el-textarea__inner) {
  min-height: 100px !important;
  font-size: 18px;
}
:deep(.cons-form .el-button) {
  width: auto;
  height: 50px;
  font-size: 18px;
}
.main {
  background: #fff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
}
.cons {
  width: 1200px;
  margin: auto;
  padding: 30px 0;
}
.cons-form {
  width: 100%;
}
.cons-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 0 0 10px 0;
}
.cons-subtitle {
  width: 100%;
  padding: 10px 30px;
  box-sizing: border-box;
  background: #f5f7fa;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  margin: auto;
  margin-bottom: 30px;
}
.custom-block {
  padding: 10px 16px;
  background-color: #ecf5ff;
  border-radius: 4px;
  border-left: 5px solid #409eff;
  margin: 20px 0 20px 0;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.con-btn {
  text-align: center;
  margin-bottom: 30px;
}
.cons-title-subtitle {
  color: #999;
  font-size: 14px;
}
.cons-title-subtitle p {
  margin: 0;
  padding: 0;
  text-align: center;
}
.qksx-list-con {
  font-size: 14px;
  padding: 20px 0 0 0;
}
.qksx-list-con:after {
  content: "";
  display: table;
  clear: both;
}
.xsqk-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xsqk-list {
  cursor: pointer;
}
.xsqk-list-title {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
}
.xsfx,
#echartsyyy {
  width: 1200px;
  height: 600px;
}
.loadings {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}
</style>
